import { AbstractControl, ValidatorFn } from '@angular/forms';

export const macroValidator = (): ValidatorFn => {
  return (control: AbstractControl) => {
    let value = control.value;

    if (typeof value === 'string') {
      value = value.trim();
    }

    // @IMPROVEMENT We could get list of macros and compare against it to verify that macro doesn't already exist

    return value !== null
        && value.length > 2
        && value[0] === '['
        && value[value.length - 1] === ']'
          ? null
          : { invalidMacro: true };
  };
};



// WEBPACK FOOTER //
// ./src/app/shared/validators/macro.validator.ts